/**
 * Retrieves a version token from sessionStorage using the specified key.
 * If the token does not exist, it generates a new one based on the current timestamp,
 * stores it in sessionStorage, and returns it.
 *
 * @param {string} [key='version_token'] - The key used to store/retrieve the version token in sessionStorage.
 * @returns {string} The version token.
 */
function getSessionVersionToken(key = 'version_token') {
  let t = sessionStorage.getItem(key);
  if (!t) {
    t = Date.now().toString();
    sessionStorage.setItem(key, t);
  }
  return t;
}

export default getSessionVersionToken;
